import { object, string } from 'yup';

import { ECode2FaForm } from '@enums/userProfile';

import { getMaxLengthErrMsg, getMinLengthErrMsg, validationErrMessages } from '@constants/validationConstants';
import { MAX_5_LENGTH } from '@constants/validationMessages';

export const schema = object({
	[ECode2FaForm.code]: string()
		.trim()
		.default('')
		.required(validationErrMessages.code2Fa)
		.min(MAX_5_LENGTH, getMinLengthErrMsg('Code', MAX_5_LENGTH))
		.max(MAX_5_LENGTH, getMaxLengthErrMsg('Code', MAX_5_LENGTH)),
});
